/**
 * Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { AttachCommand } from './attachCommand';
import { Store } from '@ngxs/store';
import { MatDialog } from '@angular/material/dialog';
import { inject } from '@angular/core';

export function attachFactory() {
    const command = new AttachCommand();
    command.setDependencies({
        store: inject(Store),
        dialog: inject(MatDialog),
    });
    return command;
}
